export const FETCH_ALL_ERP_ORDERS_BEGIN = "FETCH_ALL_ERP_ORDERS_BEGIN";
export const FETCH_ALL_ERP_ORDERS_SUCCESS = "FETCH_ALL_ERP_ORDERS_SUCCESS";
export const FETCH_ALL_ERP_ORDERS_FAILURE = "FETCH_ALL_ERP_ORDERS_FAILURE";

export const FETCH_ERP_ORDER_DETAIL_BEGIN = "FETCH_ERP_ORDER_DETAIL_BEGIN";
export const FETCH_ERP_ORDER_DETAIL_SUCCESS = "FETCH_ERP_ORDER_DETAIL_SUCCESS";
export const FETCH_ERP_ORDER_DETAIL_FAILURE = "FETCH_ERP_ORDER_DETAIL_FAILURE";

export const UPDATE_ERP_ORDER_STATUS_BEGIN = "UPDATE_ERP_ORDER_STATUS_BEGIN";
export const UPDATE_ERP_ORDER_STATUS_SUCCESS =
  "UPDATE_ERP_ORDER_STATUS_SUCCESS";
export const UPDATE_ERP_ORDER_STATUS_FAILURE =
  "UPDATE_ERP_ORDER_STATUS_FAILURE";

export const FETCH_SFA_DATA_SUCCESS = "FETCH_SFA_DATA_SUCCESS";

export const DELETE_ORDER_LINE_BEGIN = "DELETE_ORDER_LINE_BEGIN";
export const DELETE_ORDER_LINE_SUCCESS = "DELETE_ORDER_LINE_SUCCESS";
export const DELETE_ORDER_LINE_FAILURE = "DELETE_ORDER_LINE_FAILURE";

export const UPDATE_ORDER_LINE_BEGIN = "UPDATE_ORDER_LINE_BEGIN";
export const UPDATE_ORDER_LINE_SUCCESS = "UPDATE_ORDER_LINE_SUCCESS";
export const UPDATE_ORDER_LINE_FAILURE = "UPDATE_ORDER_LINE_FAILURE";

export const CONFIRM_ORDER_BEGIN = "CONFIRM_ORDER_BEGIN";
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";
export const CONFIRM_ORDER_FAILURE = "CONFIRM_ORDER_FAILURE";

export const EDIT_DELIVERY_ORDER_BEGIN = "EDIT_DELIVERY_ORDER_BEGIN";
export const EDIT_DELIVERY_ORDER_SUCCESS = "EDIT_DELIVERY_ORDER_SUCCESS";
export const EDIT_DELIVERY_ORDER_FAILURE = "EDIT_DELIVERY_ORDER_FAILURE";
